import { createContext, useContext, useState } from "react";
import api from "../common/api/api";
import { toast } from "react-toastify";
import PropTypes from "prop-types";


export const TopicsContext = createContext();

export const TopicsProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [topicsData, setTopicsData] = useState([]);
    const [validateTopicsData, setValidateTopicsData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [popupType, setPopupType] = useState(""); // managing this state for popup 
    const [selectedRow, setSelectedRow] = useState(null); // manage the state for selected row data
    const [validatCount, setValidateCount] = useState(0);
    const [oneTopicData, setOneTopicData] = useState([]);
    const [onlyTopicsDetails,setOnlyTopicsDetails]= useState([]);


    const getTopicsList = async (request) => {
        setLoading(true);
        try {
            const response = await api.topics.getAllTopicsList(request);
            if (response?.success) {
                setTopicsData(response.data.docs);
                setTotalCount(response?.data.totalDocs);
            }
        } catch (error) {
            toast.error(error?.message || "Something went wrong!");
        } finally {
            setLoading(false);
        }
    };


    const getTopcById = async (id) => {
        setLoading(true);
        try {
            const response = await api.topics.getTopicsDetailsById(id);
            if (response?.success) {
                setLoading(false);
                setOneTopicData([response.data]);
            }
        } catch (error) {
            toast.error(error?.message || "Something went wrong!");
        }
        finally {
            setLoading(false);
        }
    }

       const getTopicsById = async (id) => {
        setLoading(true);
        try {
            const response = await api.topics.getValidateTopicById(id);
            if (response?.success) {
                setLoading(false);
                setOnlyTopicsDetails(response.data);
            }
            return response;
        } catch (error) {
            toast.error(error?.message || "Something went wrong!");
        }
        finally {
            setLoading(false);
        }
    }


    const [lastValidateRequest, setLastValidateRequest] = useState(null);

    const getValidateTopicList = async (request) => {
        setLoading(true);
        const payload = request || lastValidateRequest;
        try {
            const response = await api.validateTopics.getValidteTopics(payload);
            if (response?.success) {
                setValidateTopicsData(response.data.docs);
                setValidateCount(response?.data.totalDocs);
                if (request) {
                    setLastValidateRequest(request);
                }
            }
        } catch (error) {
            toast.error(error?.message || "Something went wrong!");
        } finally {
            setLoading(false);
        }
    };

    const rejectTopic = async (request) => {
        setLoading(true);
        try {
            const response = await api.validateTopics.rejectTopics(request);
            if (response?.success) {
                toast.success(response?.message);
                getValidateTopicList();
            }
        } catch (error) {
            toast.error(error?.message || "Something went wrong!");
        }
        finally {
            setLoading(false);
        }
    }

    const validateTopic = async (request) => {
        setLoading(true)
        try {
            const response = await api.validateTopics.validateTopics(request);
            if (response?.success) {
                toast.success(response?.message);
                getValidateTopicList();
            }
        } catch (error) {
            toast.error(error?.message || "Something went wrong!");
        }
        finally {
            setLoading(false);
        }
    }



    const contextValues = {
        loading,
        getTopicsList,
        topicsData,
        getValidateTopicList,
        validateTopicsData,
        popupType,
        setPopupType,
        selectedRow,
        setSelectedRow,
        rejectTopic,
        validateTopic,
        totalCount,
        validatCount,
        getTopcById,
        oneTopicData,
        getTopicsById,
        onlyTopicsDetails,
    }
    return (
        <TopicsContext.Provider value={contextValues}>{children}</TopicsContext.Provider>
    )
}

TopicsProvider.propTypes = {
    children: PropTypes.node
};

export const useTopics = () => useContext(TopicsContext);